import { API } from "@Config/api";

export function getLandingSync() {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.get(`/landing-sync`);
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function sumbitSimulation(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(
        `/prospective-client/simulation`,
        payload
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function sendContact(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(`/prospective-client/contact`, payload);
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function userRegister(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(`/candidate-account/register`, payload);
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function clientRegister(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(`/prospective-client/register`, payload);
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function userLogin(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(`/candidate-account/login`, payload);
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function clientLogin(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(`/prospective-client/login`, payload);
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}
export function userGoogleLogin(token) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(
        `/candidate-account/google`,
        {},
        {
          headers: {
            Authorization: token,
          },
        }
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function userVerify(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(`/candidate-account/verify`, payload);
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}
export function clientVerify(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(`/prospective-client/verify`, payload);
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function profileSync() {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.get(`/candidate-account/profile-sync`);
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function setupProfile(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(`/candidate-account/profile`, payload, {
        headers: {
          Authorization: localStorage?.getItem("accessTokenUserLanding"),
        },
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function setupClientProfile(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.patch(
        `/prospective-client/complete-profile`,
        payload,
        {
          headers: {
            Authorization: localStorage?.getItem("accessTokenUserLanding"),
          },
        }
      );
      resolve(data);
    } catch (error) {
      console.log(error, "error");
      reject(error);
    }
  });
}
export function updateProfile(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.patch(`/candidate-account/profile`, payload, {
        headers: {
          Authorization: localStorage?.getItem("accessTokenUserLanding"),
        },
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}
export function reVerificationEmailOrPhoneProfile(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(
        `/candidate-account/reverification`,
        payload,
        {
          headers: {
            Authorization: localStorage?.getItem("accessTokenUserLanding"),
          },
        }
      );
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function detailProfile() {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.get(`/candidate-account/profile`, {
        headers: {
          Authorization: localStorage?.getItem("accessTokenUserLanding"),
        },
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function listLocationProfile() {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.get(`/prospective-client/location`, {
        headers: {
          Authorization: localStorage?.getItem("accessTokenUserLanding"),
        },
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function getHistoryProfile(status, search) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.get(
        `/candidate-account/profile/application-history?status=${status}&search=${search}`,
        {
          headers: {
            Authorization: localStorage.getItem("accessTokenUserLanding"),
            // Authorization: localStorage.getItem("personIdUserLanding"),
          },
        }
      );

      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function getDetailHistoryProfile(id) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.get(
        `/candidate-account/profile/application-history/${id}`,
        {
          headers: {
            Authorization: localStorage.getItem("accessTokenUserLanding"),
            // Authorization: localStorage.getItem("personIdUserLanding"),
          },
        }
      );

      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function getDataCandidateBookmark(limit = 10, page = 1, title = "") {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.get(
        `/candidate-account/bookmark?limit=${limit}&page=${page}&title=${title}`,
        {
          headers: {
            Authorization: localStorage.getItem("accessTokenUserLanding"),
          },
        }
      );

      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function createCandidateBookmark(jobPostiId) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(
        `/candidate-account/bookmark`,
        {
          jobID: jobPostiId,
        },
        {
          headers: {
            Authorization: localStorage.getItem("accessTokenUserLanding"),
          },
        }
      );

      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function deleteCandidateBookmark(jobPostiId) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.delete(
        `/candidate-account/bookmark/${jobPostiId}`,
        {
          headers: {
            Authorization: localStorage.getItem("accessTokenUserLanding"),
          },
        }
      );

      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function getDataJobPostExternal(limit = 10, page = 1, title = "") {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.get(
        `/candidate-account/external-application?limit=${limit}&page=${page}&search=${title}`,
        {
          headers: {
            Authorization: localStorage.getItem("accessTokenUserLanding"),
          },
        }
      );

      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function getJobPostingClient(limit, page, title, accessToken) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.get(
        `/prospective-client/job-post?title=${title}&page=${page}&limit=${limit}`,
        {
          headers: {
            Authorization:
              accessToken || localStorage.getItem("accessTokenUserLanding"),
          },
        }
      );

      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function getDropdownListUploadJob() {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.get(`/prospective-client/dropdown`, {
        headers: {
          Authorization: localStorage.getItem("accessTokenUserLanding"),
        },
      });

      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function getDetailJobPost(id) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.get(`/prospective-client/job-post/${id}`, {
        headers: {
          Authorization: localStorage.getItem("accessTokenUserLanding"),
        },
      });

      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function upladJobPostClient(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(`/prospective-client/job-post`, payload, {
        headers: {
          Authorization: localStorage.getItem("accessTokenUserLanding"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function editJobPostClient(id, payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.patch(
        `/prospective-client/job-post/${id}`,
        payload,
        {
          headers: {
            Authorization: localStorage.getItem("accessTokenUserLanding"),
            // "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function getCandidatePerJobPostingClient(id, limit, page, title) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.get(
        `/prospective-client/job-post/candidate-list/${id}?page=${page}&limit=${limit}0&search=${title}`,
        {
          headers: {
            Authorization: localStorage.getItem("accessTokenUserLanding"),
          },
        }
      );

      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function getDetailCandidatePerJobPostingClient(
  candidateAccountID,
  appliedJobID
) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.get(
        `/prospective-client/job-post/candidate-detail/${candidateAccountID}/${appliedJobID}`,
        {
          headers: {
            Authorization: localStorage.getItem("accessTokenUserLanding"),
          },
        }
      );

      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function checkPersonIdCandidate(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(`/candidate-account/id-number`, payload, {
        headers: {
          Authorization: localStorage.getItem("accessTokenUserLanding"),
        },
      });

      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function sendOTPCandidate(phoneNumber) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(
        `/social-media/otp`,
        { phoneNumber: phoneNumber },
        {
          headers: {
            // Authorization: sessionStorage.getItem("accessToken"),
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      );

      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function verifyOTPCandidate(hash, otp) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(
        `/social-media/verify-otp/${hash}`,
        { otp: otp },
        {
          headers: {
            // Authorization: sessionStorage.getItem("accessToken"),
            Authorization: localStorage.getItem("accessToken"),
          },
        }
      );

      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}

export function applyJob(payload) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await API.post(`/candidate-account/job-post`, payload, {
        headers: {
          // Authorization: sessionStorage.getItem("accessToken"),
          Authorization: localStorage.getItem("accessToken"),
        },
      });

      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
}
